import { render, staticRenderFns } from "./ventilation-solutions.vue?vue&type=template&id=e3673db8&scoped=true&"
import script from "./ventilation-solutions.vue?vue&type=script&lang=js&"
export * from "./ventilation-solutions.vue?vue&type=script&lang=js&"
import style0 from "./ventilation-solutions.vue?vue&type=style&index=0&id=e3673db8&lang=scss&scoped=true&"
import style1 from "./ventilation-solutions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3673db8",
  null
  
)

export default component.exports